// extracted by mini-css-extract-plugin
module.exports = {"mmboostpage":"style_mmboostpage__3HSf1","mmboostpage__calculator":"style_mmboostpage__calculator__3WIbM","mmboostpage__button":"style_mmboostpage__button__1Ylzx"};